import PaymentList from './PaymentList';

function Payment() {
  return <PaymentList />;
}

export default Payment;
